/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsOut: {
  name: 'arrows-out';
  data: string;
} = {
  name: 'arrows-out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 1a.5.5 0 0 0 .5.5h3.793L9.646 5.646a.5.5 0 1 0 .708.708L14.5 2.207V6a.5.5 0 0 0 1 0V1a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5Zm-3.146 9.354a.5.5 0 0 0-.708-.708L1.5 13.793V10a.5.5 0 0 0-1 0v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H2.207l4.147-4.146Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
